import React, { useEffect, useState } from "react";
import Header from "../components/Header";
import LeftPane from "../components/LeftPane";
import {
    MDBBadge,
    MDBBtn,
    MDBChip,
    MDBDatatable,
    MDBIcon,
    MDBModal,
    MDBModalBody,
    MDBModalContent,
    MDBModalDialog,
    MDBModalFooter,
    MDBModalHeader,
    MDBModalTitle,
    MDBTabs,
    MDBTabsContent,
    MDBTabsItem,
    MDBTabsLink,
    MDBTabsPane,
    MDBTextArea,
    MDBAlert,
    MDBRadio,
    MDBInput,
    MDBCheckbox,
    MDBTable,
    MDBTableHead,
    MDBTableBody
} from "mdb-react-ui-kit";

import { browserName, browserVersion } from "react-device-detect";
import { useLocation, useNavigate } from "react-router";
import PageError from "./PageError";
import { getcampaignAnalytics } from "../services/apiServices";
import Loader from "../components/Loader";
import ExcelExportButton from "../components/exportToExcel";

function CampaignAnalytics() {
    const navigate = useNavigate();
    const location = useLocation();
    const [apiError, setApiError] = useState(false);
    console.log(location.state);
    const [whatsAppData, setwhatsAppData] = useState([])
    const [DayFilter, setDayFilter] = useState("4");
    const [loading, setLoading] = useState(false)
    const [basicData, setBasicData] = useState({
        columns: [
            { label: 'S.No', field: 'sno', sort: false },
            { label: 'Member Name', field: 'memberName', sort: false },
            { label: 'Number', field: 'memberNumber', sort: false },
            { label: 'Sent On', field: 'sentOn', sort: false },
            { label: 'Template Name', field: 'templateName', sort: false },
            { label: 'status', field: 'status', sort: false },
            { label: "Message", field: "message", sort: false }
        ],
        rows: [],
    });
    console.log(basicData);

    const handleReload = () => {
        window.location.reload();
    };
    useEffect(() => {

        async function fetchData() {
            const update = {
                Campaignid: location.state?._id
            }
            const response = await getcampaignAnalytics(
                localStorage.getItem("loggedUserInfo") && JSON.parse(localStorage.getItem("loggedUserInfo")).gymid, update
            );
            if (!response) {
                return;
            }
            if (response === "false") {
                // Handle API error if needed
            } else {
                const segments = await response.json();
                console.log(segments);

                setwhatsAppData(segments);
            }
            // setRefresh(false)
        }
        fetchData()
    }, [])

    const mappingTemplate = (params, template) => {
        let result = template;
        params.forEach(param => {
            if (param.name && param.value) {
                const placeholder = `{{${param.name}}}`;
                const boldPlaceholder = `*${placeholder}*`;
                if (result.includes(boldPlaceholder)) {
                    result = result.replace(boldPlaceholder, `<b>${param.value}</b>`);
                } else {
                    result = result.replace(placeholder, param.value);
                }
            }
        });
        return result;
    };
    useEffect(() => {
        const popupRow = [];
        if (whatsAppData && whatsAppData.length > 0) {
            whatsAppData.forEach((item) => {
                if (item.templatevalues && item.templatevalues.length > 0) {
                    item.templatevalues.forEach((templateValue, index) => {
                        let memberName = templateValue?.memberDetails?.fname ? templateValue.memberDetails.fname + " " + templateValue.memberDetails?.lname : "--";
                        let memberNumber = templateValue?.memberDetails?.number ? templateValue.memberDetails.number : "--";

                        let message = item.template

                        if (templateValue?.customParams.length > 0) {
                            message = mappingTemplate(templateValue.customParams, item.template);
                        }

                        const rowData = {
                            sno: popupRow.length + 1,
                            memberName: memberName || "",
                            memberNumber: memberNumber || "",
                            sentOn: new Date(item.updatedAt).toLocaleString("en-IN", { timeZone: "Asia/Kolkata" }),
                            templateName: item.templatename || "",
                            status: item.status == "failure" ? "failure" : (templateValue.status || "Read"),
                            message: <div
                                className='m-0 ms-2'
                                dangerouslySetInnerHTML={{
                                    __html: message.replace(/\n/g, '<br />')
                                }}
                            ></div>,
                            originalItem: item
                        };
                        popupRow.push(rowData);
                    });
                }
            });
        }

        setBasicData(prevData => ({
            ...prevData,
            rows: popupRow
        }));

        setLoading(false);
    }, [whatsAppData]);


    function showInfo(event) {
        event.preventDefault();
        navigate("/segments&campaigns");
    }
    const downloaddata = (data, title) => {

        let tmrow = [];
        whatsAppData.length > 0 && whatsAppData.forEach((item, index) => {

            if (item.templatevalues && item.templatevalues.length > 0) {
                item.templatevalues.forEach((templateValue, index) => {
                    let rarray = [];
                    let memberName = templateValue?.memberDetails?.fname ? templateValue.memberDetails.fname + " " + templateValue.memberDetails?.lname : "--";
                    let memberNumber = templateValue?.memberDetails?.number ? templateValue.memberDetails.number : "--";

                    let message = item.template

                    if (templateValue?.customParams.length > 0) {
                        message = mappingTemplate(templateValue.customParams, item.template);
                    }
                    rarray.push(index + 1);
                    rarray.push(memberName)
                    rarray.push(memberNumber)
                    rarray.push(new Date(item.updatedAt).toLocaleString("en-IN", { timeZone: "Asia/Kolkata" }))
                    rarray.push(item.templatename)
                    rarray.push(templateValue.status)
                    rarray.push(
                        message
                            ? message.replace(/<\/?b>/g, '')
                            : ''
                    );

                    tmrow.push(rarray);
                });
            }

        });

        const update = {
            columns: [
                'S.No',
                'Member Name',
                'Number',
                'Sent On',
                'Template Name',
                'status',
                "Message",
            ],
            rows: tmrow,
        }
        ExcelExportButton(update, title);
    }

    return (
        <>
            {apiError ? (
                <PageError handleReload={handleReload} />
            ) : (
                <>
                    <LeftPane isactive="15" />
                    <Header />

                    <div
                        className="gym-main rightContent"
                    >
                        <div className="d-flex space-between align-center flex-wrap">
                            <h3 className="gym-large d-flex align-items-center">
                                <MDBIcon fas icon="arrow-left" className="me-2" onClick={(e) => showInfo(e)} />
                                <h4 className="m-0">
                                    {location.state.name}
                                </h4>
                                <MDBBtn className="ms-2" onClick={() => downloaddata(basicData, location.state.name)}>download</MDBBtn>
                            </h3>
                        </div>
                        <div>
                            <div className="mt-3">
                                {loading ? (<div className="loader-height"> <Loader /></div>) :
                                    <MDBDatatable className="whatsapptable"
                                        fixedHeader
                                        maxHeight='calc(100vh - 223px)'
                                        entries={25}
                                        paging={true}
                                        data={basicData}
                                    // onRowClick={handleRowClick}
                                    />
                                }
                            </div>
                        </div>



                    </div>


                </>
            )}
        </>
    );
}

export default CampaignAnalytics
